import captureException from 'src/common/utils/captureException';
import apiFetch from 'src/common/utils/apiFetch';
import { trackEvent } from 'src/common/3rdParty/tracking';
import { InquiryResponse } from 'src/common/types/api/v4/inquiry';
import { InquiryData } from '../types';

type InquiryResponseMinimal = Pick<InquiryResponse, 'id' | 'thread_id'>;

const submitInquiry = async (
  inquiryData: InquiryData,
  listingId: string,
): Promise<InquiryResponseMinimal | null> => {
  try {
    const url = '/api/v4/inquiries/';
    const response = await apiFetch<InquiryResponseMinimal>(url, {
      method: 'POST',
      body: JSON.stringify({
        ...inquiryData,
        boat: listingId,
      }),
    });

    if (response?.id) {
      // Send conversion event to Google AdWords when on Production
      // where we have defined the conversion ID in the environment variables.
      if (process.env.NEXT_PUBLIC_ADWORDS_CONVERSION_INQUIRY) {
        trackEvent('conversion', {
          send_to: process.env.NEXT_PUBLIC_ADWORDS_CONVERSION_INQUIRY,
        });
      }
      return response;
    }
  } catch (error) {
    captureException(error);
  }
  return null;
};

export default submitInquiry;
